import { useQuery } from "@tanstack/react-query";
import qs from "qs";
import { strapiGetCollection } from "@/lib/strapi";
import { PageAttributes } from "@/types/pages";

const PAGE_FIELDS_PARAMS = qs.stringify(
	{
		populate: {
			pageBuilder: {
				on: {
					// direct media only — * at component level is safe (doesn't deep-populate media internals)
					"hero.hero": { populate: "*" },
					"hero.hero-simple": { populate: "*" },
					"card.card-info": { populate: "*" },
					"cta.call-to-action": { populate: { button: "*" } },
					"faq-section.faq-section": { populate: { faqs: "*" } },
					// nested components that contain media — image uses fields selection to avoid the `related` error
					"features-section.features-section": {
						populate: {
							image: { fields: ["url", "alternativeText", "width", "height", "mime", "formats"] },
							listItems: { populate: "*" },
						},
					},
					"steps-section.steps-section": {
						populate: {
							image: { fields: ["url", "alternativeText", "width", "height", "mime", "formats"] },
							listItems: { populate: "*" },
						},
					},
					"doula-type.doula-type": {
						populate: { doulaTypes: { populate: "*" } },
					},
					"metrics-grid.metrics-grid": {
						populate: { metrics: { populate: "*" } },
					},
				},
			},
		},
		fields: ["pageTitle", "slug"],
		status: "published",
		pagination: { pageSize: 100 },
	},
	{ encodeValuesOnly: true },
);

const PAGE_QUERY_OPTS = {
	staleTime: Infinity, // static marketing content — only refetch on page reload
	gcTime: Infinity,
	retry: 1,
} as const;

export function usePages() {
	return useQuery({
		queryKey: ["pages"],
		queryFn: async () => {
			return await strapiGetCollection<PageAttributes>(
				`/pages?${PAGE_FIELDS_PARAMS}`,
			);
		},
		...PAGE_QUERY_OPTS,
	});
}
